<template>
  <ESnippetBase
    :title="$t('web.snippet.videos.title')"
    class="videos-snippet"
    data-test-id="videos-snippet"
  >
    <ul class="videos-snippet__list" :aria-label="$t('web.snippet.videos.title')">
      <li
        v-for="(item, index) in items"
        :key="index"
        class="videos-snippet__item snippet__item"
        data-test-id="videos-snippet-item"
      >
        <ESnippetCard
          v-bind="item"
          data-test-id="videos-snippet-card"
          :duration="item.duration"
        >
          <template #title-start>
            <div class="videos-snippet__source" data-test-id="videos-snippet-source">
              {{ item.source }}
            </div>
          </template>
          <time
            v-if="item.date"
            class="videos-snippet__date"
            :datetime="item.date"
            data-test-id="videos-snippet-date"
          >
            {{ formatDate(item.date) }}
          </time>
        </ESnippetCard>
      </li>
    </ul>
    <template #footer>
      <EButton
        as="a"
        variant="outline"
        :href="moreUrl"
        icon="videos"
        size="s"
        class="videos-snippet__more"
        data-test-id="videos-snippet-more"
      >
        {{ $t('web.snippet.videos.more') }}
      </EButton>
    </template>
  </ESnippetBase>
</template>

<script>
import { mapState } from 'vuex';

import { getUrlQuery } from '~~/common/js/universal/search';
import { localiseDate } from '~~/common/js/universal/datetime';
import EButton from '~~/common/vue/components/button';
import ESnippetCard from '~~/search/common/vue/components/snippets/card';
import ESnippetBase from '~~/search/common/vue/components/snippets/base';

const itemProperties = ['url', 'title', 'source', 'date', 'description', 'thumbnailUrl'];
const validateItem = (item) => itemProperties.every((property) => property in item);

export default {
  components: {
    ESnippetBase,
    ESnippetCard,
    EButton,
  },
  props: {
    items: {
      type: Array,
      required: true,
      validator: (value) => Array.isArray(value) && value.every(validateItem),
    },
  },
  computed: {
    ...mapState('global', ['locale']),
    moreUrl() {
      const query = getUrlQuery(this.$route.query, this.$store.state.user);
      return this.$router.resolve({ path: '/videos', query }).href;
    },
  },
  methods: {
    formatDate(string) {
      return localiseDate(this.locale, new Date(string), { month: 'short' }) ?? '';
    },
  },
};
</script>

<style lang="scss" scoped>
.videos-snippet__list {
  display: flex;
  margin: 0;
  padding: 0;
  list-style: none;
}

.videos-snippet__item {
  display: inline-flex;
  flex-shrink: 0;
  padding: $space-1s $space-2s;
  scroll-snap-align: start;
  width: calc(#{$snippet-item-width-mobile} + var(--snippet-item-padding));

  @include desktop {
    .mainline & {
      width: calc(100% / 3 + var(--snippet-item-padding));
    }

    .sidebar & {
      width: calc(100% / 2 + var(--snippet-item-padding));
    }
  }
}

.videos-snippet__source {
  @extend %ellipsis;

  color: var(--color-url);
}

.videos-snippet__date {
  @extend %ellipsis;

  color: var(--color-text-secondary);
  display: block;
}
</style>
